module.exports = __webpack_public_path__ + "img/precise_localization.678ad541.png";